import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { 
  fetchRFQList
} from 'ducks/rfq'
import {
  columns
} from './AttributeData'
import { 
  requestForQuotationCreatePath ,
  requestForQuotationDetailPath,
  requestForQuotationEditPath
} from '../..'
import { 
  ProcurementContainer,
  ProcurementBody
} from '../styled'
import {
  MainBodyContent,
  CustomButton,
  SearchList,
  TablePagination
} from 'components'

import { RFQListCont } from './styled'

const RequestForQuotation = (props) => {

  const { 
    rfqList,
    valueForm
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchRFQList({page:1,size:pageSize})
  },[])

  return (
    <MainBodyContent
      headerTitle="Request for Quotation"
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(requestForQuotationCreatePath)}
            icon="plus"
            btnColor="gray"
            title="Create"
          />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} placeholder='Doc No., Title, Requester' fetchAPI={props.fetchRFQList} formSearchName='formSearchRFQ' filterDate filterStatus/>
          <RFQListCont>
            <ReactTable 
              data={Object.keys(rfqList).length>0?rfqList.data:[]}
              columns={columns.tRFQs}
              defaultPageSize={userPageSize}
              noDataText="No RequestForQuotation found"
              previousText={<Icon name="arrow alternate circle left" />}
              nextText={<Icon name="arrow alternate circle right" />}
              className="-striped -highlight"

              PaginationComponent={TablePagination}
              pages={Object.keys(rfqList).length>0?rfqList.totalPage:0}
              currentPage={Object.keys(rfqList).length>0?rfqList.page:0}
              onPageChange={(pageIndex) => {
                props.fetchRFQList({...valueForm,page:pageIndex+1,size:pageSize})
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchRFQList({...valueForm,page:pageIndex+1,size:pageSize})
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5].indexOf(rowInfo.original.status) >= 0) {
                        window.open(requestForQuotationEditPath(rowInfo.original.id))
                      } else {
                        window.open(requestForQuotationDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </RFQListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = state => ({
  rfqList: state.rfq.rfqList,
  valueForm: getFormValues('formSearchRFQ')(state)
})

const mapDispatchToProps = {
  fetchRFQList
}

const contForm = reduxForm({
  form: 'formSearchRFQ',
  enableReinitialize: true,
})(RequestForQuotation)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
